import React from 'react';
import SharedItemCells from './SharedItemCells';
import IItemProps from './IItemProps';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { IAppraisalFeeViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const AppraisalFee: React.FC<
  IItemProps & IHasItemDataProps<IAppraisalFeeViewItem> & Required<IHasItemEventProps<IAppraisalFeeViewItem>>
> = (props) => {
  return (
    <div data-test-id={`Appraisal-fee-${props.data.id}`}>
      <SharedItemCells
        {...props}
        readOnly={!!props.data.parent_id || !props.hasEditPermissions}
        showRemove={!props.data.parent_id}
        nettedOutDisplay={props.data.parent_id ? 'none' : 'input'}
      >
        Appraisal Fee
      </SharedItemCells>
    </div>
  );
};
